import api from './api';

export const taskService = {
  getAll: async (params = {}) => {
    const response = await api.get('/tasks', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/tasks/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/tasks', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/tasks/${id}`, data);
    return response.data;
  },

  updateStatus: async (id, status, order) => {
    const response = await api.patch(`/tasks/${id}/status`, { status, order });
    return response.data;
  },

  reorder: async (tasks) => {
    const response = await api.patch('/tasks/reorder', { tasks });
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/tasks/${id}`);
    return response.data;
  },

  addAssignee: async (taskId, userId) => {
    const response = await api.post(`/tasks/${taskId}/assignees`, { userId });
    return response.data;
  },

  removeAssignee: async (taskId, userId) => {
    const response = await api.delete(`/tasks/${taskId}/assignees/${userId}`);
    return response.data;
  },

  // Attachments
  getAttachments: async (taskId) => {
    const response = await api.get(`/tasks/${taskId}/attachments`);
    return response.data;
  },

  addAttachment: async (taskId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/tasks/${taskId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  addAttachments: async (taskId, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    const response = await api.post(`/tasks/${taskId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  deleteAttachment: async (attachmentId) => {
    const response = await api.delete(`/tasks/attachments/${attachmentId}`);
    return response.data;
  },
};

export default taskService;
